// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jvYy","icon":"styles_icon__VZs2X"};